var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  d: "M12.008 15.5a.6.6 0 0 0 .473-.193l5.35-5.651c.112-.13.172-.301.169-.477a.7.7 0 0 0-.19-.469.63.63 0 0 0-.444-.2.63.63 0 0 0-.45.18l-4.91 5.19-4.91-5.19a.63.63 0 0 0-.456-.19.63.63 0 0 0-.45.2.7.7 0 0 0-.19.477.7.7 0 0 0 .18.48l5.35 5.649a.63.63 0 0 0 .477.193"
})));
export default SvgArrowDown;